import { ReactElement } from "react";

import {
  TextField,
  ListProps,
  Filter,
  FilterProps,
  ReferenceField,
  DateField,
  BooleanField,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  RichTextField,
} from "react-admin";
import {
  DEFAULT_PER_PAGE,
  IdFilter,
  MAX_RECORDS_PER_PAGE,
  SearchFilter,
} from "../../../../lib/common";
import {
  CustomizableList,
  CustomizableDatagrid,
  ListRowActions,
} from "../../../../lib/components";
import { RESOURCE_NAME_ITEM_SEGMENTS } from "./constants";
import { RESOURCE_NAME_ITEM_CLASS } from "../itemsClass";
import { RESOURCE_NAME_ACCOUNT } from "../../../../lib/modules/accounts/accounts/constants";
import { COMMON_DATE_TIME_FORMAT } from "../../../../lib/core";

const ListFilters = (props: Omit<FilterProps, "children">) => (
  <Filter {...props}>
    <SearchFilter alwaysOn={true} key="search"></SearchFilter>
    <IdFilter
      source="id"
      label="components.controls.filters.idFilter.label"
      key="id"
    />

    <ReferenceArrayInput
      label="resources.itemSegments.filters.itemClassId"
      source="itemClassId"
      reference={RESOURCE_NAME_ITEM_CLASS}
      perPage={MAX_RECORDS_PER_PAGE}
      sort={{ field: "name", order: "ASC" }}
      key="itemClassId"
    >
      <AutocompleteArrayInput
        optionText="displayLabel"
        optionValue="id"
        resettable={true}
        allowEmpty={false}
      />
    </ReferenceArrayInput>
  </Filter>
);
const defaultColumns = [
  "name",
  "number",
  "description",
  "parentId",
  "itemClassId",
];
const ItemSegmentList = (props: ListProps): ReactElement => {
  return (
    <CustomizableList
      {...props}
      sort={{ field: "name", order: "ASC" }}
      perPage={DEFAULT_PER_PAGE}
      filters={<ListFilters />}
      defaultColumns={defaultColumns}
    >
      <CustomizableDatagrid optimized>
        <TextField source="number" />
        <TextField source="name" />
        <RichTextField source="description" />
        <ReferenceField
          source="parentId"
          reference={RESOURCE_NAME_ITEM_SEGMENTS}
        >
          <TextField source="displayLabel" />
        </ReferenceField>
        <ReferenceField
          source="itemClassId"
          reference={RESOURCE_NAME_ITEM_CLASS}
        >
          <TextField source="displayLabel" />
        </ReferenceField>
        <ReferenceField source="accountId" reference={RESOURCE_NAME_ACCOUNT} >
          <TextField source="displayLabel" />
        </ReferenceField>
        <DateField source="createdAt" options={COMMON_DATE_TIME_FORMAT} />
        <DateField source="updatedAt" options={COMMON_DATE_TIME_FORMAT} />
        <TextField source="id" />
        <TextField source="version" />
        <BooleanField source="isActive" />
        <ListRowActions />
      </CustomizableDatagrid>
    </CustomizableList>
  );
};

export { ItemSegmentList };
